import {INyxService} from "./nyx.service.interface";
import {ServiceBase} from "../ServiceBase";

export class NyxService extends ServiceBase implements INyxService {
    get useNewIntegration(): boolean {
        if(this.services.device.hybrid.isEmbedded) {
            return this.services.hybrid.isNyxIframeSupported() && this.services.configuration.servicesConfigs.NYX.useNewIntegration;
        } else {
            return this.services.configuration.servicesConfigs.NYX.useNewIntegration;
        }
    }
}